import React from "react";

const CompanyDelete = () => {
  return <h1>Customer Delete</h1>;
};

export default CompanyDelete;
